var _path, _path2, _circle, _path3, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRunStatementRulef(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7098 9.6357C19.7098 12.5983 17.3082 14.9999 14.3456 14.9999C11.383 14.9999 8.98138 12.5983 8.98138 9.6357C8.98138 6.67313 11.383 4.27148 14.3456 4.27148C17.3082 4.27148 19.7098 6.67313 19.7098 9.6357Z",
    fill: "#ADE2FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8283 14.5769C18.1396 14.773 18.1396 15.227 17.8283 15.4231L15.1415 17.1153C14.8085 17.325 14.375 17.0857 14.375 16.6922L14.375 13.3078C14.375 12.9143 14.8085 12.675 15.1415 12.8847L17.8283 14.5769Z",
    stroke: "#272932",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.55449,
    cy: 18.8448,
    r: 1.84478,
    stroke: "#272932",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 3.75488H7.5L6.86365 12.5072C6.8135 13.1969 6.23932 13.7309 5.5478 13.7309V13.7309C4.86178 13.7309 4.29023 13.2051 4.23307 12.5215L3.5 3.75488Z",
    stroke: "#272932",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 15,
    r: 6,
    stroke: "#272932",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRunStatementRulef);
export default __webpack_public_path__ + "static/media/Run Statement Rule f.36f7c51e38e1012f1e19f0cfa8207395.svg";
export { ForwardRef as ReactComponent };